import { z } from 'zod';
import { VendorStatus } from '../../constants/vendor-status.js';
import { newContactsInputSchema } from '../contact/new-contacts-input.js';
import { createVendorAddressPairInputSchema } from '../vendor-address/create-address-pair-input.js';
import { nonNegativeInt, nonNegativeNumber, optionalUuidString, requiredUuidString, optionalTrimmedNullableEmail, optionalTrimmedNullableString, rejectPhoneContextInjection, } from '../zod-helpers/index.js';
import { VENDOR_CONSTRAINTS } from './constraints.js';
import { checkVendorIdentity } from './rules.js';
export const createVendorInputSchema = z
    .object({
    name: z.string().trim().max(VENDOR_CONSTRAINTS.name.maxLength),
    url: z.string().max(VENDOR_CONSTRAINTS.url.maxLength).optional().nullable(),
    email: optionalTrimmedNullableEmail(VENDOR_CONSTRAINTS.email.maxLength, `Invalid ${VENDOR_CONSTRAINTS.email.label.toLowerCase()}.`),
    phone: rejectPhoneContextInjection(optionalTrimmedNullableString(VENDOR_CONSTRAINTS.phone.maxLength)),
    note: optionalTrimmedNullableString(VENDOR_CONSTRAINTS.note.maxLength),
    currencyId: optionalUuidString('Invalid currency selection.').optional().nullable(),
    paymentTermsId: requiredUuidString(`${VENDOR_CONSTRAINTS.paymentTerms.label} is required.`, 'Invalid payment terms selection.'),
    shipTermsId: requiredUuidString(`${VENDOR_CONSTRAINTS.shipTerms.label} is required.`, 'Invalid ship terms selection.'),
    carrierId: requiredUuidString(`${VENDOR_CONSTRAINTS.carrier.label} is required.`, 'Invalid carrier selection.'),
    creditLimit: nonNegativeNumber(VENDOR_CONSTRAINTS.creditLimit.label).optional().nullable(),
    leadTime: nonNegativeInt(VENDOR_CONSTRAINTS.leadTime.label).optional().nullable(),
    minOrderAmount: nonNegativeNumber(VENDOR_CONSTRAINTS.minOrderAmount.label)
        .optional()
        .nullable(),
    statusId: z.enum(VendorStatus, 'Invalid vendor status.').optional().nullable(),
    address: createVendorAddressPairInputSchema.optional().nullable(),
    contacts: newContactsInputSchema.optional().nullable(),
})
    .superRefine((input, context) => {
    for (const issue of checkVendorIdentity(input)) {
        context.addIssue({ code: 'custom', message: issue.message, path: [issue.path] });
    }
});
//# sourceMappingURL=create-input.js.map